import { replacePersonaPlaceholders } from "../adonis.helpers";
import { useAdonisChat } from "../AdonisChatProvider/AdonisChatProvider";

import { getPersonaImage } from "./../assets/getPersonaImage";

interface AdonisCTAText {
  header: string;
  subheader: string;
  chat_box: string;
  chat_submit: string;
}

type AdonisCTAVariation1Props = {
  readonly onClick: () => void;
  readonly ctaText?: AdonisCTAText;
};

const AdonisCTAVariation1 = ({
  onClick,
  ctaText,
}: AdonisCTAVariation1Props) => {
  const { persona } = useAdonisChat();

  const defaultText = {
    header: `Find the Right Treatment with {Name}`,
    subheader: `{pronoun}'s the answer to all your questions.`,
    chat_box: "What are your goals?",
    chat_submit: `ASK {name}`,
  };

  const mergedText: AdonisCTAText = {
    header: ctaText?.header ?? defaultText.header,
    subheader: ctaText?.subheader ?? defaultText.subheader,
    chat_box: ctaText?.chat_box ?? defaultText.chat_box,
    chat_submit: ctaText?.chat_submit ?? defaultText.chat_submit,
  };

  const text: AdonisCTAText = {
    header: replacePersonaPlaceholders(mergedText.header, persona),
    subheader: replacePersonaPlaceholders(mergedText.subheader, persona),
    chat_box: replacePersonaPlaceholders(mergedText.chat_box, persona),
    chat_submit: replacePersonaPlaceholders(mergedText.chat_submit, persona),
  };

  return (
    <button
      className="relative box-border w-full cursor-pointer overflow-hidden bg-[linear-gradient(0deg,_#BDA280_0%,_#EADAC5_100%)] px-4 py-5 text-center"
      onClick={onClick}
    >
      <img
        className="absolute bottom-0 left-0 h-[100px] w-[108px] translate-y-[3px] object-contain"
        src={getPersonaImage(persona?.name).clear}
        alt={persona.name ?? "Adonis"}
      />
      <div className="font-serif text-h3">{text.header}</div>
      <div className="mt-1 font-sans text-body2">{text.subheader}</div>
      <div className="mt-5 flex justify-end">
        <div className="box-border flex w-4/5 items-center justify-between rounded-full border-[2px] border-[#BDA280] bg-white p-1">
          <div className="ml-3 font-sans text-body2 text-[#727272]">
            {text.chat_box}
          </div>
          <p className="whitespace-nowrap rounded-full bg-[#BDA280] px-3 py-2 font-sans text-bold3 text-white">
            {text.chat_submit}
          </p>
        </div>
      </div>
    </button>
  );
};

export default AdonisCTAVariation1;
